/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "index",
                type: "uint32",
            },
        ],
        name: "GuardianSetAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "payload",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "consistencyLevel",
                type: "uint8",
            },
        ],
        name: "LogMessagePublished",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentGuardianSetIndex",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "index",
                type: "uint32",
            },
        ],
        name: "getGuardianSet",
        outputs: [
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "keys",
                        type: "address[]",
                    },
                    {
                        internalType: "uint32",
                        name: "expirationTime",
                        type: "uint32",
                    },
                ],
                internalType: "struct Structs.GuardianSet",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getGuardianSetExpiry",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "messageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "emitter",
                type: "address",
            },
        ],
        name: "nextSequence",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "parseAndVerifyVM",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedUpgrade",
                type: "bytes",
            },
        ],
        name: "parseContractUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chain",
                        type: "uint16",
                    },
                    {
                        internalType: "address",
                        name: "newContract",
                        type: "address",
                    },
                ],
                internalType: "struct GovernanceStructs.ContractUpgrade",
                name: "cu",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedUpgrade",
                type: "bytes",
            },
        ],
        name: "parseGuardianSetUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chain",
                        type: "uint16",
                    },
                    {
                        components: [
                            {
                                internalType: "address[]",
                                name: "keys",
                                type: "address[]",
                            },
                            {
                                internalType: "uint32",
                                name: "expirationTime",
                                type: "uint32",
                            },
                        ],
                        internalType: "struct Structs.GuardianSet",
                        name: "newGuardianSet",
                        type: "tuple",
                    },
                    {
                        internalType: "uint32",
                        name: "newGuardianSetIndex",
                        type: "uint32",
                    },
                ],
                internalType: "struct GovernanceStructs.GuardianSetUpgrade",
                name: "gsu",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedSetMessageFee",
                type: "bytes",
            },
        ],
        name: "parseSetMessageFee",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint256",
                        name: "messageFee",
                        type: "uint256",
                    },
                ],
                internalType: "struct GovernanceStructs.SetMessageFee",
                name: "smf",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedTransferFees",
                type: "bytes",
            },
        ],
        name: "parseTransferFees",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "recipient",
                        type: "bytes32",
                    },
                ],
                internalType: "struct GovernanceStructs.TransferFees",
                name: "tf",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "parseVM",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitContractUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitNewGuardianSet",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitSetMessageFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitTransferFees",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "guardianIndex",
                        type: "uint8",
                    },
                ],
                internalType: "struct Structs.Signature[]",
                name: "signatures",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "keys",
                        type: "address[]",
                    },
                    {
                        internalType: "uint32",
                        name: "expirationTime",
                        type: "uint32",
                    },
                ],
                internalType: "struct Structs.GuardianSet",
                name: "guardianSet",
                type: "tuple",
            },
        ],
        name: "verifySignatures",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
        ],
        name: "verifyVM",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
            {
                internalType: "bytes",
                name: "payload",
                type: "bytes",
            },
            {
                internalType: "uint8",
                name: "consistencyLevel",
                type: "uint8",
            },
        ],
        name: "publishMessage",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
];
var _bytecode = "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";
var Implementation__factory = /** @class */ (function (_super) {
    __extends(Implementation__factory, _super);
    function Implementation__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    Implementation__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    Implementation__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    Implementation__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Implementation__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Implementation__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    Implementation__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    Implementation__factory.bytecode = _bytecode;
    Implementation__factory.abi = _abi;
    return Implementation__factory;
}(ContractFactory));
export { Implementation__factory };
